import { render, staticRenderFns } from "./NewChipInformation.vue?vue&type=template&id=1ce979fa&scoped=true"
import script from "./NewChipInformation.vue?vue&type=script&lang=js"
export * from "./NewChipInformation.vue?vue&type=script&lang=js"
import style0 from "./NewChipInformation.vue?vue&type=style&index=0&id=1ce979fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce979fa",
  null
  
)

export default component.exports